import state from './state';
import Store from '../base';
import mutations from './mutations';


export default class Rsvps extends Store {
    constructor(name, model, ng){

        state.listview = name;
        state.model = model;

        super({state, ng, mutations});
    }
}



// WEBPACK FOOTER //
// ./src/app/store/rsvps/index.js